<h1>Latest data of RV Kronprins Haakon</h1>

@if (geometry(); as geo) {
  <mat-card appearance="outlined" class="npdc-leaflet">
    <app-leaflet-group [geometry]="geo"></app-leaflet-group>
  </mat-card>
}

<p>
  This viewer is based on data records of the
  <a routerlink href="/dataset/{{ datasetId }}">“RV Kronprins Haakon positions” dataset</a>.
</p>

<mat-list>
  <mat-list-item>
    <mat-icon matListItemIcon>place</mat-icon>
    <span matListItemTitle>Position (WGS84)</span>
    <span matListItemLine>
      @if (position(); as pos) {
        Lat: {{ pos[1] | number: '1.1-4' }} Lng: {{ pos[0] | number: '1.1-4' }}
      } @else {
        N/A
      }
    </span>
  </mat-list-item>

  @let old = isOutdated();
  <mat-list-item [class.npdc-error-list-item]="old">
    <mat-icon matListItemIcon>{{ old ? 'error' : 'date_range' }}</mat-icon>
    <span matListItemTitle>Time (UTC)</span>
    <span matListItemLine>
      @if (date(); as dt) {
        {{ dt | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }}
      } @else {
        N/A
      }
    </span>
  </mat-list-item>

  <mat-list-item>
    <mat-icon matListItemIcon>speed</mat-icon>
    <span matListItemTitle>Current speed over ground (SOG)</span>
    <span matListItemLine>
      @if (currentSOG(); as csog) {
        {{ csog | number: '1.1-1' }} kn
      } @else {
        N/A
      }
    </span>
  </mat-list-item>

  <mat-list-item>
    <mat-icon matListItemIcon>speed</mat-icon>
    <span matListItemTitle>Effective speed over ground (SOG)
      @if (timeDiff(); as td) {
        per {{ td / 60 | number: '1.0-0' }} min
      }
    </span>
    <span matListItemLine>
      @if (effectiveSOG(); as sog) {
        {{ sog | number: '1.1-1' }} kn
      } @else {
        N/A
      }
    </span>
  </mat-list-item>

  <mat-list-item>
    <mat-icon matListItemIcon>explore</mat-icon>
    <span matListItemTitle>Effective course over ground (COG)
      @if (timeDiff(); as td) {
        per {{ td / 60 | number: '1.0-0' }} min
      }
    </span>
    <span matListItemLine>
      @if (effectiveCOG(); as cog) {
        {{ cog | number: '1.0-0' }}°
      } @else {
        N/A
      }
    </span>
  </mat-list-item>
</mat-list>
